import { render, staticRenderFns } from "./BannerConfig.vue?vue&type=template&id=60dc2ea4&"
import script from "./BannerConfig.vue?vue&type=script&lang=js&"
export * from "./BannerConfig.vue?vue&type=script&lang=js&"
import style0 from "./BannerConfig.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports